import React, { useState } from 'react'
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import AlertDialog from '../../../../../../../components/AlertDialog/index.es6'
import ButtonInc from '../../../../../../../shared-ui/ButtonInc'

const DeleteDocument = props => {
  // Hooks must run on every render, before the early return below.
  const [confirmed, setConfirmed] = useState(false)

  if (!props.DocumentToDelete) {
    return ''
  }

  const deleteDocument = () => {
    setConfirmed(true)
    props.deleteDocument(props.DocumentToDelete)
  }
  const cancel = () => {
    setConfirmed(false)
    props.resetDocumentToDelete()
  }
  const handleDocumentDeletedSuccessfully = () => {
    props.resetDeleteDocumentSuccessAlert()
    props.resetDocumentToDelete()
    window.location.reload()
  }
  const handleDocumentDeleteError = () => {
    props.resetDocumentToDelete()
  }

  return (
    <>
      <AlertDialog
        custom
        show={!!props.showDeleteDocumentProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText="ok"
        showCancel={false}
        showConfirm={false}
        cancelBtnText="cancel"
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Deleting Document...</h2>
      </AlertDialog>

      <Dialog
        open={!confirmed}
        onClose={cancel}
        aria-labelledby="delete-document-title"
        aria-describedby="delete-document-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="delete-document-title">Delete document</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-document-description">
            Are you sure you want to delete
            {props.DocumentToDelete.description ? (
              <strong> {props.DocumentToDelete.description}</strong>
            ) : (
              ' this document'
            )}
            ? This cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonInc btnType="secondary" onClick={cancel} autoFocus>
            Cancel
          </ButtonInc>
          <ButtonInc onClick={deleteDocument} style={{ background: '#B3251E' }}>
            Delete
          </ButtonInc>
        </DialogActions>
      </Dialog>
      <AlertDialog
        success
        show={props.showDeleteDocumentSuccessAlert}
        size="sm"
        title="Document deleted"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => {
          handleDocumentDeletedSuccessfully()
        }}
        confirmBtnText="Ok"
        showCancel={false}
        showConfirm={false}
        cancelBtnText="Delete"
        confirmBtnCssClass
      >
        <div>
          <ButtonInc
            onClick={() => {
              handleDocumentDeletedSuccessfully()
            }}
            style={{ background: 'green' }}
          >
            OK
          </ButtonInc>
        </div>
      </AlertDialog>
      <AlertDialog
        show={props.showDeleteDocumentErrorAlert}
        danger
        title="Error deleting document"
        onConfirm={() => handleDocumentDeleteError()}
        confirmBtnText="Try again"
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        Could not delete document
      </AlertDialog>
    </>
  )
}

export default DeleteDocument
